import { FC, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { lazy } from 'utils/generic/lazy';
import { getUser } from 'store/selectors/user-data';

const { _ProfitBoostManager } = lazy(
  () =>
    import(
      /* webpackChunkName: "_ProfitBoostManager" */ 'newelements/_Betslip/managers/ProfitBoostManager/manager'
    )
);

// @Todo need to handel here conditionally mounting
export const ProfitBoostManager: FC = () => {
  const { has_free_bets } = useSelector(getUser);

  const isProfitBoostAvailable = !!has_free_bets;

  if (!isProfitBoostAvailable) {
    return null;
  }

  return (
    <Suspense>
      <_ProfitBoostManager />
    </Suspense>
  );
};
